import { ADD_CLIENTS, ADD_CLIENTS_FAILED, ADD_CLIENTS_SUCCESS, CLIENTS, CLIENTS_FAILED, CLIENTS_SUCCESS, SEARCHEDCLIENT, SEARCHEDCLIENT_FAILED, SEARCHEDCLIENT_SUCCESS, SINGLE_CLIENTS, SINGLE_CLIENTS_FAILED, SINGLE_CLIENTS_SUCCESS, UPDATE_CLIENTS, UPDATE_CLIENTS_FAILED, UPDATE_CLIENTS_SUCCESS } from "./actionTypes"


const initialState = {
    clients: [],
    searchedClients: [],
    singleClient : {},
    addClient : "",
    updateClient : "",
    loading: false,
    success: false,
    error: ''
}

export const clientsReducer = (state = initialState, action) => {
    switch (action.type) {
        case CLIENTS: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case CLIENTS_SUCCESS: return {
            ...state,
            clients: action.payload,
            loading: false,
            success: true,
            error: ''
        }
        case CLIENTS_FAILED: return {
            ...state,
            clients: [],
            loading: false,
            success: false,
            error: action.payload
        }
        case SEARCHEDCLIENT: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case SEARCHEDCLIENT_SUCCESS: return {
            ...state,
            searchedClients: action.payload,
            loading: false,
            success: true,
            error: ''
        }
        case SEARCHEDCLIENT_FAILED: return {
            ...state,
            loading: false,
            success: false,
            error: action.payload
        }
        case SINGLE_CLIENTS : return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case SINGLE_CLIENTS_SUCCESS: return {
            ...state,
            singleClient: action.payload,
            loading: false,
            success: true,
            error: ''
        }
        case SINGLE_CLIENTS_FAILED: return {
            ...state,
            singleClient: [],
            loading: false,
            success: false,
            error: action.payload
        }
        case ADD_CLIENTS : return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case ADD_CLIENTS_SUCCESS: return {
            ...state,
            addClient: action.payload,
            loading: false,
            success: true,
            error: ''
        }
        case ADD_CLIENTS_FAILED: return {
            ...state,
            addClient: [],
            loading: false,
            success: false,
            error: action.payload
        }
        case UPDATE_CLIENTS : return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case UPDATE_CLIENTS_SUCCESS: return {
            ...state,
            updateClient: action.payload,
            loading: false,
            success: true,
            error: ''
        }
        case UPDATE_CLIENTS_FAILED: return {
            ...state,
            updateClient: [],
            loading: false,
            success: false,
            error: action.payload
        }
        default:
            return state;
    }
}